module.exports = __webpack_public_path__ + "img/camion5.562af53f.jpg";